import { DatePicker } from "antd";
import type { RangePickerProps } from "antd/lib/date-picker";
import dayjs, { type Dayjs } from "dayjs";
import { useState } from "react";
import { DATE_FORMAT } from "std/const/date";
import { intervalToRangePicker, rangePickerToInterval, type TRangeDatePicker } from "std/datetime";

const { RangePicker } = DatePicker;

type InputCalendarioRange = Omit<RangePickerProps, "placeholder" | "onChange"> &
	Partial<{
		placeholder: [string, string];
		onChange: (value: Optional<Interval<Dayjs>>) => void;
		value: Optional<Interval<Dayjs>>;
	}>;

export function InputCalendarioRange(props: InputCalendarioRange) {
	const { style, placeholder, onChange, value, ...rest } = props;

	const [innerValue, setInnerValue] = useState<TRangeDatePicker>(value ? intervalToRangePicker(value) : value);

	const handleOnChange = (e: TRangeDatePicker) => {
		setInnerValue(e);
		const newDateRange = rangePickerToInterval(e);

		if (onChange) {
			onChange(newDateRange);
		}
	};

	return (
		<RangePicker
			format={DATE_FORMAT}
			presets={[
				{ label: "Hoje", value: [dayjs(), dayjs()] },
				{
					label: "Esta semana",
					value: [dayjs().startOf("week"), dayjs().endOf("week")],
				},
				{
					label: "Este mês",
					value: [dayjs().startOf("month"), dayjs().endOf("month")],
				},
				{
					label: "Últimos 30 dias",
					value: [dayjs().subtract(30, "days"), dayjs()],
				},
				{
					label: "Últimos 60 dias",
					value: [dayjs().subtract(60, "days"), dayjs()],
				},
				{
					label: "Últimos 90 dias",
					value: [dayjs().subtract(90, "days"), dayjs()],
				},
				{
					label: "Próximos 90 dias",
					value: [dayjs(), dayjs().add(90, "days")],
				},
			]}
			value={innerValue}
			style={{ width: "100%", ...style }}
			placeholder={placeholder}
			onChange={(rangeDate) => handleOnChange(rangeDate)}
			{...rest}
		/>
	);
}
